/* Collection page: results toolbar sort, scroll-to-toolbar after AJAX updates, clean swatch tooltips. */
(() => {
  /* sort select in the results toolbar: keep current filters, change sort_by */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest && e.target.closest('[data-hg-sort]');
    if (!sel) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    url.hash = 'hg-tools';
    window.location.assign(url.toString());
  });
  /* our toolbar button opens the theme's mobile filter drawer */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('[data-hg-open-filters]');
    if (!btn) return;
    const summary = document.querySelector('.mobile-facets__wrapper summary, .mobile-facets__disclosure > summary');
    if (summary) summary.click();
  });
  /* keep the results toolbar at the top of the viewport after filtering / sorting / paging */
  const headerOffset = (goingUp) => {
    const h = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    return (goingUp ? h : 0) + 20;
  };
  const toTools = (smooth, force) => {
    const t = document.getElementById('hg-tools');
    if (!t) return;
    const rect = t.getBoundingClientRect();
    const y = rect.top + window.scrollY;
    const goingUp = y < window.scrollY;
    const top = Math.max(0, y - headerOffset(goingUp));
    /* only when the user has scrolled past the toolbar (its top edge is above the viewport) */
    if (!force && rect.top >= 0) return;
    if (Math.abs(top - window.scrollY) < 8) return;
    window.scrollTo({ top, behavior: smooth ? 'smooth' : 'auto' });
  };
  let scrollTimer;
  const afterUpdate = () => { clearTimeout(scrollTimer); scrollTimer = setTimeout(() => toTools(true), 60); };
  if (location.hash === '#hg-tools') window.addEventListener('load', () => toTools(false, true), { once: true });

  const watch = () => {
    const target = document.getElementById('ProductGridContainer');
    if (!target || target.dataset.hgWatch) return;
    target.dataset.hgWatch = '1';
    new MutationObserver(() => { afterUpdate(); }).observe(target, { childList: true });
  };
  const fixTitles = () => {
    document.querySelectorAll('#main-collection-filters [title^="gid://"], .mobile-facets [title^="gid://"]').forEach((el) => {
      const row = el.closest('.facets__item, li');
      const name = row && row.querySelector('.facet-checkbox__text-label');
      if (name) el.setAttribute('title', name.textContent.trim()); else el.removeAttribute('title');
    });
  };
  fixTitles();
  new MutationObserver(fixTitles).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  watch();
  new MutationObserver(watch).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
})();
